import React, { useEffect, useContext, useState } from 'react';
import { Navigate, Link ,useNavigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc';
import {strEncode,strDecode} from '../../encrpt';
import {API_BASE_URL} from "../../apiConfig.jsx";
import logo from "../../assets/img/logo-dark.png";

function LoginV1() {
	const context = useContext(AppSettings);
	const [formData, setFormData] = useState({ email: '', password: '' });
	const [redirect, setRedirect] = useState(false);
    const [error, setError] = useState(null);
	
	useEffect(() => {
		context.handleSetAppHeaderNone(true);
		context.handleSetAppSidebarNone(true);
		context.handleSetAppContentClass('p-0');
		
		return function cleanUp() {
			context.handleSetAppHeaderNone(false);
			context.handleSetAppSidebarNone(false);
			context.handleSetAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);
	
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Clean inputs
    const email = cleanStr(formData.email);
    const password = cleanPass(formData.password);

    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/auth/signin`,
            { email, password },
            { headers: { "Content-Type": "application/json" } }
        );

        // Check if login is successful
             if (response.data?.id > 0) {
             const userData = response.data;
             const response_link = await axios.post(
              `${API_BASE_URL}/api/custom/selectall`,
              { t: strEncode('pmis_user_perm_navigation')},{ headers: { 'Content-Type': 'application/json' } },
              { headers: { "Content-Type": "application/json" } }
             ); 
              
           console.log("response_link.data.n_user_email",response_link.data)
           const user_nav_email = response_link.data[0].n_user_email;
             // Store user session data
            localStorage.setItem("authToken", userData.accessToken);
            localStorage.setItem("navemail", user_nav_email);
            localStorage.setItem("user", JSON.stringify(userData));
            sessionStorage.setItem("user", JSON.stringify(userData));

            setRedirect(true); // Trigger redirect after login
        } else {
            setError("Invalid credentials");
        }
    } catch (error) {
        setError(error.response?.data?.message || "Login failed");
    }
};

  function handleChange (event){
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  
  
	if (redirect) {
		return <Navigate to='/dashboard/v1' />;
	}
  
	return (
		<div className="login login-v1">
			<div className="login-container">
				<div className="login-header">
					<div className="brand">
						<div className="d-flex align-items-center">
							<img src={logo} alt="PMIS-PROLAC" style={{width:"150px"}}/><b>PMIS</b> Prolac
						</div>
						<small></small>
					</div>
					<div className="icon">
						<i className="fa fa-lock"></i>
					</div>
				</div>
				<div className="login-body">
					<div className="login-content fs-13px">
					<form onSubmit={handleSubmit}>
              <div className="form-floating mb-20px">
                <input
                  type="email"
                  name="email"
                  className="form-control fs-13px h-45px"
                  placeholder="Adresse courriel"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="emailAddress" className="d-flex align-items-center py-0">
				Adresse courriel
                </label>
              </div>
              <div className="form-floating mb-20px">
                <input
                  type="password"
                  name="password"
                  className="form-control fs-13px h-45px"
                  placeholder="Mot de passe"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="password" className="d-flex align-items-center py-0">
				Mot de passe
                </label>
              </div>
              <div className="form-check mb-20px">
                <input className="form-check-input" type="checkbox" id="rememberMe" />
                <label className="form-check-label" htmlFor="rememberMe">
				Souvenez-vous de moi
                </label>
              </div>
              <div className="login-buttons">
                <button type="submit" className="btn h-45px btn-theme d-block w-100 btn-lg">
				Connexion
                </button>
              </div>
              {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
            </form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default LoginV1;